import { render, staticRenderFns } from "./SendChatMessage.vue?vue&type=template&id=1c3483a5&"
import script from "./SendChatMessage.vue?vue&type=script&lang=js&"
export * from "./SendChatMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports